import React, { Component } from 'react';
import classNames from 'classnames';
import { openInviteContactScreen } from '@/utils/ShellUtils';
import cssStyles from './Contacts.css';

class EmptyContactsState extends Component {
  onInviteClick = () => {
    openInviteContactScreen('empty_sidebar_invite');
  };

  render() {
    return (
      <div className={cssStyles.empty_roster_container}>
        <div
          className={classNames(
            cssStyles.empty_roster_image,
            cssStyles.empty_contacts
          )}
        />
        <div>
          No contacts yet.
          <div
            role='button'
            onKeyDown={() => {}}
            tabIndex={0}
            className={cssStyles.invite_text}
            onClick={this.onInviteClick}
          >
            Invite contacts
          </div>
        </div>
      </div>
    );
  }
}

export default EmptyContactsState;



// WEBPACK FOOTER //
// ./src/components/roster/EmptyContactsState.js